import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TransactionStatus } from './../../enums/transaction-status.enum';
import * as fromAccountActions from './../../store/actions/accounts/accounts.actions';
import { AppState } from './../../store/index';
import {
  createServerDate,
  generateFutureDate,
  generatePastDate
} from './date.utils';

export const setAnnouncementsWithPredefinedFilters = (
  store: Store<AppState>,
  router: Router
): void => {
  const accountTransactionFilter = {
    transactionStatus: TransactionStatus.Pending,
    paymentDateFrom: createServerDate(generatePastDate(0, 0, 0).toString()),
    paymentDateTo: createServerDate(generateFutureDate(0, 0, 0).toString())
  };
  store.dispatch(
    fromAccountActions.accountFilterTransactionFromAccounts({
      accountTransactionsFilters: accountTransactionFilter
    })
  );
  router.navigateByUrl('/accounts/(details:transactions)');
};
